(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["GA-Compliant-Tab"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const mainTabs = document.querySelectorAll('.main-tab');
  const innerTabContainers = document.querySelectorAll('.inner-tab-container');

  // --- Slugify function (for clean URLs) ---
  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  // --- Activate main tab ---
  function activateMainTab(index) {
    mainTabs.forEach((tab, i) => tab.classList.toggle('active', i === index));
    innerTabContainers.forEach((container, i) => {
      container.style.display = i === index ? 'block' : 'none';
      if (i === index) {
        const firstInnerTab = container.querySelector('.inner-tab');
        if (firstInnerTab) firstInnerTab.click();
      }
    });
  }

  // --- Activate inner tab ---
  function activateInnerTab(innerTab) {
    const container = innerTab.closest('.inner-tab-container');
    if (!container) return;

    container.querySelectorAll('.inner-tab').forEach(t => t.classList.remove('active'));
    container.querySelectorAll('.inner-content').forEach(c => c.classList.remove('active'));

    innerTab.classList.add('active');
    const content = container.querySelector(`.inner-content[data-content="${innerTab.dataset.inner}"]`);
    if (content) content.classList.add('active');
  }

  // --- Initial tab setup ---
  mainTabs.forEach((tab, i) => {
    tab.addEventListener('click', () => {
      activateMainTab(i);
      const firstInner = innerTabContainers[i]?.querySelector('.inner-tab.active') || innerTabContainers[i]?.querySelector('.inner-tab');
      if (firstInner) updateURL(firstInner.textContent);
    });
  });

  document.querySelectorAll('.inner-tab').forEach(innerTab => {
    innerTab.addEventListener('click', () => {
      activateInnerTab(innerTab);
      updateURL(innerTab.textContent);
    });
  });

  // --- URL Update (when clicking a tab) ---
  function updateURL(tabText) {
    const slug = slugify(tabText);
    const newUrl = `${window.location.origin}${window.location.pathname}?tab=${slug}`;
    window.history.replaceState(null, '', newUrl);
  }

  // --- Load tab from URL (on page load) ---
  const urlParams = new URLSearchParams(window.location.search);
  let targetSlug = urlParams.get('tab');
  if (!targetSlug && window.location.hash) targetSlug = window.location.hash.substring(1);

  if (targetSlug) {
    const matchInner = Array.from(document.querySelectorAll('.inner-tab')).find(inner => slugify(inner.textContent) === targetSlug);
    if (matchInner) {
      const parentContainer = matchInner.closest('.inner-tab-container');
      const mainIndex = Array.from(innerTabContainers).indexOf(parentContainer);
      if (mainIndex !== -1) activateMainTab(mainIndex);
      setTimeout(() => matchInner.click(), 200);
    } else {
      activateMainTab(0);
    }
  } else {
    activateMainTab(0);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-tab"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const mainTabs = document.querySelectorAll('.main-tab');
  const innerTabContainers = document.querySelectorAll('.inner-tab-container');

  mainTabs.forEach((tab, i) => {
    tab.addEventListener('click', () => {
      mainTabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      innerTabContainers.forEach(c => c.style.display = 'none');
      const target = document.querySelector(`.inner-tab-container[data-tab-content="${i + 1}"]`);
      if (target) {
        target.style.display = 'block';
        const firstInnerTab = target.querySelector('.inner-tab');
        if (firstInnerTab) firstInnerTab.click();
      }
    });
  });

  document.querySelectorAll('.inner-tabs').forEach(container => {
    container.querySelectorAll('.inner-tab').forEach(innerTab => {
      innerTab.addEventListener('click', () => {
        const parent = innerTab.closest('.inner-tab-container');
        parent.querySelectorAll('.inner-tab').forEach(t => t.classList.remove('active'));
        parent.querySelectorAll('.inner-content').forEach(c => c.classList.remove('active'));

        innerTab.classList.add('active');
        const content = parent.querySelector(`.inner-content[data-content="${innerTab.dataset.inner}"]`);
        if (content) content.classList.add('active');
      });
    });
  });

  // Activate first main and inner tab on page load
  if (mainTabs.length) mainTabs[0].click();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-new"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const mainTabs = document.querySelectorAll('.main-tab');
  const innerTabContainers = document.querySelectorAll('.inner-tab-container');
  const innerTabs = document.querySelectorAll('.inner-tab');

  // 🔹 Activate main tab
  function activateMainTab(index) {
    mainTabs.forEach((tab, i) => tab.classList.toggle('active', i === index));
    innerTabContainers.forEach((container, i) => {
      const active = i === index;
      container.style.display = active ? 'block' : 'none';
      if (active) {
        const firstInnerTab = container.querySelector('.inner-tab');
        if (firstInnerTab) firstInnerTab.click();
      }
    });
  }

  // 🔹 Activate inner tab
  function activateInnerTab(innerTab) {
    const container = innerTab.closest('.inner-tab-container');
    if (!container) return;

    container.querySelectorAll('.inner-tab').forEach(t => t.classList.remove('active'));
    container.querySelectorAll('.inner-content').forEach(c => c.classList.remove('active'));

    innerTab.classList.add('active');
    const content = container.querySelector(`.inner-content[data-content="${innerTab.dataset.inner}"]`);
    if (content) content.classList.add('active');

    // 🔹 Update URL hash with slugified name
    const slug = innerTab.textContent.trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    history.replaceState(null, null, '#' + slug);
  }

  // 🔹 Find & open tab by slug
  function openTabByHash(hash) {
    if (!hash) return false;
    const slug = hash.replace('#', '');
    let matchedTab = null;

    innerTabs.forEach(tab => {
      const tabSlug = tab.textContent.trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
      if (tabSlug === slug) matchedTab = tab;
    });

    if (matchedTab) {
      const container = matchedTab.closest('.inner-tab-container');
      const index = Array.from(innerTabContainers).indexOf(container);
      if (index > -1) {
        activateMainTab(index);
        activateInnerTab(matchedTab);
        matchedTab.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return true;
    }
    return false;
  }

  // 🔹 Add click events
  mainTabs.forEach((tab, i) => tab.addEventListener('click', () => activateMainTab(i)));
  innerTabs.forEach(tab => tab.addEventListener('click', () => activateInnerTab(tab)));

  // 🔹 On load: open hash tab or default first
  if (!openTabByHash(window.location.hash)) {
    activateMainTab(0);
  }

  // 🔹 Handle hashchange (if user clicks browser back/forward)
  window.addEventListener('hashchange', () => openTabByHash(window.location.hash));
});

  } catch(e) { console.error(e); }
})();
})();
